<template>
  <div>

    <div class="row">

      <div class="col-xs-12" v-if="quiz">
        <h2> {{quiz.title}} : Préconisations & Analyses</h2>
      </div>

      <div class="col-xs-12 mt-20">
          <div class="portlet light portlet-fit portlet-form bordered col-xs-12 p-0" v-if="quiz">
              <div class="portlet-title col-xs-12 ">
                  <div class="caption tabbable-line p-0">
                      <ul class="nav nav-tabs ">
                          <li class="active">
                              <a data-toggle="tab" aria-expanded="false" v-on:click="show.list_actions = true">
                                <i class=" icon-layers"></i>
                                <span class="caption-subject sbold uppercase">Actions </span>
                              </a>
                          </li>
                          <li class="">
                              <a data-toggle="tab" aria-expanded="true" v-on:click="show.analysis = true">
                                <i class=" icon-note"></i>
                                <span class="caption-subject sbold uppercase">Analyse</span>
                              </a>
                          </li>
                      </ul>
                  </div>
              </div>

              <div class="portlet-body col-xs-12">

                <analysis v-if="show.analysis"></analysis>

                <list-actions v-if="show.list_actions" :quiz.sync="quiz" ></list-actions>

              </div>

          </div>
          <div class="row m-0" v-else>
            <div class="col-md-12 page-404 mt-50 pb-50">
                <div class="number font-green"> 404 </div>
                <div class="details">
                    <h3>Oops ! Questionnaire non trouvé.</h3>
                    <p> Nous n'avons pas réussi à trouver ce questionnaire.
                        <br>
                        Vérifiez'url et tentez de recharger la page.
                    </p>
                </div>
            </div>
          </div>
      </div>

    </div>
  </div>
</template>


<script>

  import quizzes from '../../requests/quizzes.js'
  // var config = require('../../config/settings.json');
  import Analysis from './preconizations/analysis'
  import ListActions from './preconizations/list'

  export default {
    components: {
      Analysis,
      ListActions
    },
    data(){
      return{
        show:{
          analysis:false,
          list_actions:true
        },
        quiz:{}
      }
    },
    watch:{
      'show.analysis':function(){
        if(this.show.analysis){
          this.show.list_actions = false;
        }
      },
      'show.list_actions':function(){
        if(this.show.list_actions){
          this.show.analysis = false;
        }
      }
    },
    mounted:function(){
      var parent = this;
      quizzes.getBySlug(this,this.$route.params.slug,function(quiz,err){
        if(quiz){
          parent.quiz = quiz;
        }
        else{
          parent.quiz = null;
          toastr.error("Impossible de récupérer le questionnaire.","ERREUR");
        }
      })
    },
    methods:{

    }
  }
</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// preconizations.vue?a8677f54